export default "__VITE_ASSET__DXIBcjYi__"